const fontSizes = [15, 18, 20, 24, 30, 36, 44, 52, 68, 84]

fontSizes.body = fontSizes[0]

export default fontSizes
